module.exports = __webpack_public_path__ + "img/2.f4541220.png";